import React from "react";
import { Quote } from "lucide-react";
import { testimonials } from "../mock";

const Testimonials = () => {
  const doubled = [...testimonials, ...testimonials];
  return (
    <section className="relative py-24 md:py-28 overflow-hidden marquee-pause cosmic-panel">
      <div className="stars opacity-70" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 mb-14 text-center">
        <div className="divider-star justify-center"><span>Soul Reviews</span></div>
        <h2 className="font-serif text-4xl md:text-5xl leading-tight mt-8 text-[#EDE3D0] max-w-3xl mx-auto">
          What emerges on the other side of 
          <span className="italic text-[#D4A85B]"> this work.</span>
        </h2>
      </div>

      <div className="relative">
        <div className="flex gap-6 w-max animate-marquee">
          {doubled.map((t, idx) => (
            <figure
              key={idx}
              className="w-[360px] md:w-[420px] shrink-0 rounded-3xl border border-[#D4A85B]/25 bg-[#12081E]/70 p-8 backdrop-blur"
            >
              <Quote className="text-[#D4A85B]" size={22} />
              <blockquote className="font-serif italic text-[22px] leading-snug mt-4 text-[#EDE3D0]">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-[#D4A85B]/15">
                <div className="font-medium text-[#EDE3D0]">{t.name}</div>
                <div className="text-[10px] uppercase tracking-[0.28em] text-[#D4A85B]/80 mt-1">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0A0714] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0A0714] to-transparent" />
      </div>
    </section>
  );
};

export default Testimonials;
